import React from 'react'
import * as Bs from 'react-bootstrap'
import ReactMixin from 'react-mixin'
import DocumentTitle from 'react-document-title'
import Input from '_/shared/components/input'
import { Map } from 'immutable'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'

const expMonths = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  .map(month => ({ label: month, value: month })))

const yr = (new Date()).getFullYear()
const expYears = Object.freeze([
  yr, yr+1, yr+2, yr+3, yr+4, yr+5, yr+6,
  yr+7, yr+8, yr+9, yr+10, yr+11, yr+12
].map(year => ({ label: year, value: year })))

/**
 * Change credit card page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ChangeCard extends React.Component {
  static contextTypes = {
    store: React.PropTypes.object.isRequired,
    router: React.PropTypes.func.isRequired
  }

  constructor (props, context) {
    super(props, context)
    this.state = { card: Map() }
  }

  async updateCard (evt) {
    evt.preventDefault()
    try {
      const card = this.state.card.toJS()
      await this.context.store.post('/account/stripe', {
        card: card
      })
      this.context.router.goBack()
    }
    catch (er) {
      this.setState({
        stripeError: er.response.body.error
      })
    }
  }

  render () {
    const ln = createLinkToImmutable(this, 'card')
    const { stripeError } = this.state

    return (
      <DocumentTitle title="Change credit card">
        <div>
          <h3>Change credit card</h3>
          <p>This will associate a new/updated credit card with your account. You will be able to use this card for purchases and it also will be the card that will invoiced for subscription payments.</p>
          {stripeError && <Bs.Alert bsStyle="danger">{stripeError}</Bs.Alert>}
          <Bs.Row>
            <Bs.Col xs={7}>
              <form onSubmit={::this.updateCard}>
                <Input
                  type="text"
                  valueLink={ln('name')}
                  label="Cardholder's full name" />
                <Input
                  type="text"
                  valueLink={ln('number')}
                  label="Card number" />
                <Input
                  type="text"
                  valueLink={ln('cvc')}
                  label="CVC" />
                <Bs.Row>
                  <Bs.Col xs={5}>
                    <b>Expiration</b>
                  </Bs.Col>
                  <Bs.Col xs={3}>
                    <Input
                      type="select"
                      valueLink={ln('expMonth')}
                      placeholder="Month"
                      options={expMonths} />
                  </Bs.Col>
                  <Bs.Col xs={4}>
                    <Input
                      type="select"
                      placeholder="Year"
                      valueLink={ln('expYear')}
                      options={expYears} />
                  </Bs.Col>
                </Bs.Row>
                <p>
                  <Bs.Button
                    type="submit"
                    bsStyle="primary">
                    Save changes
                  </Bs.Button>
                </p>
              </form>
            </Bs.Col>
            <Bs.Col xs={5}>
              <Bs.Well>
                <p><b>REDIComps accepts the following credit cards</b>:</p>
                <ul>
                  <li>Visa</li>
                  <li>MasterCard</li>
                  <li>American Express</li>
                  <li>JCB</li>
                  <li>Discover</li>
                  <li>Diners Club</li>
                </ul>
              </Bs.Well>
            </Bs.Col>
          </Bs.Row>
        </div>
      </DocumentTitle>
    )
  }
}

export default ChangeCard



// WEBPACK FOOTER //
// ./modules/shared/pages/account/changeCard.js